import { computed } from 'vue';
import { storeToRefs } from 'pinia';
import { useMeStore } from '@/services/UserService/useMeStore';

/**
 * `conflictCheck2` decides which conflict check the route renders.
 *
 * Two sources, deliberately. In production the flag arrives on `/me`. Locally it is
 * set in `src/env/env.json` under `features`, which reaches the app as
 * `window.leanlaw.features` — the axios interceptors send it on as the
 * `x-leanlaw-features` header, but the Vue store reads `/me` through a pipeline that
 * does not, so the env.json value would otherwise never show up in `me.features`.
 * Reading both is what makes the local switch work without a backend change.
 *
 * `window.leanlaw.features` is an existing key on that object, not a new one.
 */
export function useConflictCheckFlag() {
  const meStore = useMeStore();
  const { features } = storeToRefs(meStore);

  const localOverride = (): boolean =>
    Boolean(
      (window as { leanlaw?: { features?: Record<string, boolean> } }).leanlaw
        ?.features?.conflictCheck2,
    );

  const isEnabled = computed(
    () => Boolean(features.value?.conflictCheck2) || localOverride(),
  );

  return { isEnabled };
}

export default useConflictCheckFlag;
